/* eslint global-require: off */
/* eslint @typescript-eslint/no-var-requires: off */
// disabled in nodejs threads
const hasDOM = typeof window !== 'undefined' && typeof document !== 'undefined';
const debug = process.env.REACT_APP_MODE === 'dev';
if (hasDOM) {
    // @ts-ignore
    window['dataLayer'] = dataLayer();
}
let globalProperties = {};
let installFunction = () => { };
const init = (apiKey) => {
    if (debug) {
        console.log('gtmApi.init()');
    }
    if (!hasDOM) {
        console.log('GTM disabled in context');
        return;
    }
    if (!apiKey) {
        return;
    }
    installFunction = gtmInstaller(apiKey);
    installFunction();
};
function gtmInstaller(apiKey) {
    let installed = false;
    return function () {
        if (!installed) {
            installed = true;
            event('gtm.js', { 'gtm.start': new Date().getTime() });
            const scriptElement = document.createElement('script');
            scriptElement.src = `https://www.googletagmanager.com/gtm.js?id=${apiKey}`;
            document.body.appendChild(scriptElement);
        }
    };
}
const updateTracking = (_track) => {
    // NOP
};
const onLogin = (externalId) => {
    if (debug) {
        console.log('gtmApi.onLogin()', externalId);
    }
    if (!hasDOM) {
        return;
    }
    // NOP
};
const onLogout = () => {
    if (debug) {
        console.log('gtmApi.onLogout()');
    }
    if (!hasDOM) {
        return;
    }
    // NOP
};
const event = (name, properties = {}) => {
    if (debug) {
        console.log('gtmApi.event()', name, properties);
    }
    if (!hasDOM) {
        return;
    }
    dataLayer().push({
        ...globalProperties,
        ...properties,
        event: name
    });
};
const register = (properties) => {
    if (debug) {
        console.log('gtmApi.register()', properties);
    }
    if (!hasDOM) {
        return;
    }
    globalProperties = { ...globalProperties, ...properties };
};
const setProperties = (properties) => {
    if (debug) {
        console.log('gtmApi.setProperties()', properties);
    }
    if (!hasDOM) {
        return;
    }
    dataLayer().push({
        ...globalProperties,
        properties
    });
};
function dataLayer() {
    // @ts-ignore
    return window['dataLayer'] || [];
}
export const gtmApi = {
    init,
    updateTracking,
    onLogin,
    onLogout,
    register,
    event,
    setProperties
};
//# sourceMappingURL=gtm.js.map